var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5466 12.8133L17.88 13.08C17.74 12.9733 17.5933 12.8867 17.4333 12.82L17.3333 12.1133C17.32 12.0467 17.2666 12 17.2 12H16.1333C16.0666 12 16.0133 12.0467 16.0066 12.1133L15.9066 12.82C15.7466 12.8867 15.5933 12.9733 15.46 13.08L14.7933 12.8133C14.7333 12.7933 14.66 12.8133 14.6333 12.8733L14.1 13.7933C14.0666 13.8533 14.08 13.9267 14.1333 13.9667L14.7 14.4067C14.68 14.4867 14.6666 14.58 14.6666 14.6667C14.6666 14.7533 14.6733 14.84 14.6866 14.9267L14.1266 15.3667C14.0733 15.4067 14.06 15.48 14.0933 15.5333L14.6266 16.46C14.66 16.52 14.7266 16.54 14.7933 16.52L15.4533 16.2533C15.5933 16.36 15.74 16.4467 15.9066 16.5133L16 17.22C16.0133 17.2867 16.0666 17.3333 16.1333 17.3333H17.2C17.2666 17.3333 17.32 17.2867 17.3333 17.22L17.4333 16.5133C17.5933 16.4467 17.7466 16.36 17.88 16.2533L18.54 16.52C18.6 16.5467 18.6733 16.52 18.7 16.46L19.2333 15.5333C19.2666 15.4733 19.2533 15.4067 19.2 15.3667L18.6466 14.9267C18.66 14.84 18.6666 14.7533 18.6666 14.6667C18.6666 14.5733 18.66 14.4867 18.6466 14.4067L19.2133 13.9667C19.2666 13.9267 19.28 13.8533 19.2466 13.7933L18.7133 12.8733C18.68 12.8133 18.6066 12.7933 18.5466 12.8133ZM16.6666 15.62C16.14 15.62 15.7133 15.1933 15.7133 14.6667C15.7133 14.14 16.14 13.7133 16.6666 13.7133C17.1933 13.7133 17.62 14.14 17.62 14.6667C17.62 15.1933 17.1933 15.62 16.6666 15.62Z",
    fill: "#027BCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2933 14.04C21.0066 11.86 19.14 10.1333 16.94 10.0067C16.8466 10 16.76 10 16.6666 10C14.3133 10 12.38 11.74 12.0533 14L10.7666 16.32C10.4933 16.76 10.8133 17.3333 11.3333 17.3333H12V18.6667C12 19.4 12.6 20 13.3333 20H14V22H18.6666V18.88C20.4133 18.0467 21.5666 16.16 21.2933 14.04ZM17.9266 17.7533L17.3333 18.0333V20.6667H15.3333V18.6667H13.3333V16H12.4666L13.3533 14.4467C13.4733 12.7067 14.9 11.3333 16.6666 11.3333C18.5066 11.3333 20 12.8267 20 14.6667C20 16.06 19.14 17.2533 17.9266 17.7533Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAi);
export default __webpack_public_path__ + "static/media/healthAI.c51b6ebb0b8a3e0a6ed532f8458d0c95.svg";
export { ForwardRef as ReactComponent };